import { GRUNDWORTSCHATZ_HESSEN } from "./blitzlesen-grundwortschatz";
import { PSEUDOWOERTER } from "./blitzlesen-pseudowoerter";
import { BLITZLESEN_EINFACHE_SILBEN, BLITZLESEN_KONSONANTENVERBINDUNGEN } from "./blitzlesen-silben";
import { normalizeReadingText, readingMaterialSchema, suggestReadingMaterial, type ReadingMaterial } from "./reading-progression";

// Editorial exceptions to the regular segmentation of the supplied finite corpus.
// h is annotated at its actual position; compounds retain spoken h and morpheme boundaries.
const overrides: Record<string, string> = {
  "häschen": "h ä s ch e n", "bisschen": "b i s s ch e n", "nächste": "n ä ch s t e",
  "linie": "l i n i e", "lineal": "l i n e a l", "medien": "m e d i e n", "ferien": "f e r i e n",
  "herstellen": "h e r st e l l e n", "verstecken": "v e r st e ck e n",
  "fahrrad": "f a h:silent r r a d", "weihnachten": "w ei h:silent n a ch t e n",
  "frühstück": "f r ü h:silent st ü ck", "ungefähr": "u n g e f ä h:silent r",
};
const silentH = new Set(`ihm ihn ihr mehr sehr ohne früh kuh nah reh schuh zeh bahn bohren fahren fehlen fehler fühlen höhle huhn jahr kühl lehrer nehmen ohr rühren uhr wohl wohnen zahl zahn zehn ähnlich bezahlen erzählen frühling frühstück gefahr ungefähr verkehr während draht stuhl`.split(" "));
const syllableH = new Set(`blühen drehen gehen reihe ruhe sehen ziehen stehen`.split(" "));

const supplied = [...GRUNDWORTSCHATZ_HESSEN, ...PSEUDOWOERTER, ...BLITZLESEN_EINFACHE_SILBEN, ...BLITZLESEN_KONSONANTENVERBINDUNGEN, "Mama", "Mamma", "Schaf", "Häschen", "mahlen"];
export const REVIEWED_READING_MATERIALS: Readonly<Record<string, ReadingMaterial>> = Object.freeze(Object.fromEntries(supplied.map((text) => {
  const key = normalizeReadingText(text);
  const entry = suggestReadingMaterial(text);
  if (overrides[key]) entry.segments = overrides[key]!.split(" ");
  else if (silentH.has(key) || key === "mahlen") entry.segments = entry.segments.map((unit, index) => unit === "h" && index > 0 ? "h:silent" : unit);
  else if (syllableH.has(key)) entry.segments = entry.segments.map((unit, index) => unit === "h" && index > 0 ? "h:syllable" : unit);
  return [key, readingMaterialSchema.parse({ ...entry, reviewed: true })];
})));

export function readingMaterialFor(text: string, descriptions: readonly ReadingMaterial[] = []): ReadingMaterial | undefined {
  const key = normalizeReadingText(text);
  // Even an unreviewed local description replaces the bundled entry: a revoked
  // editorial confirmation must not silently fall back to a global description.
  return descriptions.find((entry) => normalizeReadingText(entry.text) === key) ?? REVIEWED_READING_MATERIALS[key];
}
